import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-payment-info-message',
  templateUrl: `${environment.pageFolder}/payment-info-message.${environment.pageFolder}.component.html`,
  styleUrls: [`${environment.pageFolder}/payment-info-message.${environment.pageFolder}.component.sass`],
  standalone: true,
  imports: [CommonModule, TranslateModule]
})
export class PaymentInfoMessageComponent {
  @Input() paymentInfoMessages!: string;

  ngOnInit() {
    (document.location.pathname.split("/cart/")[0] === "/buy-season-ticket" || document.location.pathname.endsWith("/50")) && (this.paymentInfoMessages = "season-ticket");
  }
}
